<script>
  import feather from 'feather-icons';
  import { afterUpdate, onMount } from 'svelte';
  import Router from '@ui/pico/router.svelte';
  import AnimateCdn from '@ui/pico/animate-cdn.svelte';

  import { userStoreKey } from './config';
  import { routes } from './routes';
  import { account, accountForms, accountSites, app } from './store';
  import FontAwesomeCdn from './pages/components/font-awesome-cdn.svelte';
  import RemixIcons from './pages/components/cdn/remix-icons.svelte';
  import { formsGetter, sitesGetter } from './services';

  const authRoute = '/enter';
  export let params;

  afterUpdate(() => {
    // document.querySelector('.firebase-emulator-warning')?.remove();
    feather.replace();
  });

  onMount(async () => {
    // sites and forms setup in store
    if ($account) {
      await sitesGetter();
      console.info('App.onMount sites', $accountSites);
      await formsGetter();
      console.info('App.onMount forms', $accountForms);
    }
  });
</script>

<svelte:head>
  <title>{$app?.titleBase}</title>
</svelte:head>

<RemixIcons />
<FontAwesomeCdn />
<AnimateCdn />

<Router {userStoreKey} {routes} {authRoute} defaultProtect={false} />
